import {Box, Typography, Grid} from '@mui/material';

import {useTranslation} from 'react-i18next';
import {useAppSelector} from '@/redux-store/store';

import CompanyInfosForManager from './company-infos-for-manager';
import {useCompanyContext} from '@/contexts/admin/companies';
import CompanyInfos from './company-infox';
import CompanyInfosForTrainer from './company-infos-for-trainer';

const CompanyDashboard = () => {
  const {t} = useTranslation();

  const companyContext = useCompanyContext();
  const userRole = useAppSelector((state) => state.auth.keycloakUser?.userRole);
  const {isUserHealthManager, isPublicCompany} = useAppSelector(
    (state) => state.auth
  );
  const companyDataPublicOrManager = useAppSelector(
    (state) => state.company.company
  );
  const companyDataEmployee = useAppSelector(
    (state) => state.userInfos.userInfos.companies?.[0]?.id || null
  );

  const userData = useAppSelector((state) => state.userInfos.userInfos);

  const companyData =
    isUserHealthManager || isPublicCompany
      ? companyDataPublicOrManager
      : companyDataEmployee;

  if (!companyData) {
    return null;
  }

  const companyStatistics = companyContext.companyStatistics || null;

  const companyLogoFromReduxAltered = `${
    companyData.logo
  }?timestamp=${Date.now()}`;

  return (
    <>
      <Box sx={{flexGrow: 1, marginTop: 4, marginBottom: {xs: 2, sm: 0}}}>
        {userRole !== 'TRAINER' && (
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid
              container
              item
              xs={12}
              sm="auto"
              justifyContent="center"
              sx={{flexDirection: {xs: 'column', sm: 'row'}}}
            >
              <Grid item xs={12} sm="auto">
                <Typography
                  variant="h4"
                  align="center"
                  sx={{marginBottom: {xs: 1, sm: 0}}}
                >
                  {t('welcome')},&nbsp;
                </Typography>
              </Grid>
              <Grid item xs={12} sm="auto">
                <Typography variant="h4" align="center">
                  {companyData.title}
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={6} marginTop={1} marginBottom={1}>
              <Box
                component="img"
                alt={t('company_logo')}
                src={companyLogoFromReduxAltered}
                sx={{
                  display: 'block',
                  mx: 'auto',
                  maxWidth: {xs: '250px', sm: '300px'},
                  maxHeight: {xs: '100px', sm: '120px'}
                }}
              />
            </Grid>
          </Grid>
        )}

        <Grid container spacing={2} justifyContent="center" marginTop={3}>
          <Grid item xs={12} sm={8} lg={10}>
            {isUserHealthManager ? (
              <CompanyInfosForManager
                companyData={companyDataPublicOrManager}
                companyStatistics={companyStatistics}
                statisticsSx={{
                  marginLeft: 3,
                  marginTop: 3
                }}
              />
            ) : userRole === 'TRAINER' ? (
              <CompanyInfosForTrainer userData={userData} />
            ) : (
              companyDataEmployee && (
                <CompanyInfos companyData={companyDataEmployee} />
              )
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CompanyDashboard;
